module.exports = __webpack_public_path__ + "static/media/705DalvigneyStNW_2018-06-25_125.4b7d8340.jpg";